import { render } from "./AppProfile.vue?vue&type=template&id=49c3e2fc"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
script.render = render

export default script